import { render } from "./Nav.vue?vue&type=template&id=dabf388a&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"

import "./Nav.vue?vue&type=style&index=0&id=dabf388a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dabf388a"

export default script